module.exports = __webpack_public_path__ + "images/v4b_header.1348fc8c.png";